const AWS_REGIONS = new Map([
  ["eu-west-1", "ie"],
  ["eu-west-3", "fr"],
  ["eu-central-1", "de"],
  ["eu-south-1", "it"],
  ["us-east-1", "us"],
  ["us-west-1", "us"],
]);
export default AWS_REGIONS;
